// /accounts/$accountSlug — LAYOUT route. Owns nothing visual itself;
// just supplies the <Outlet /> so deeper child routes
// (./index = AccountDetailPage, ./tenants/$tenantSlug, etc.) actually
// render in place. This is the pattern every nested resource page in
// Tasks 5-7 will follow.

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/accounts/$accountSlug")({
  component: () => <Outlet />,
});
